import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { ServiceModel } from './model';
import { adapter, ServiceCatalogState } from './state';

export const stateName: string = 'serviceCatalog';
export const selectEntityState: MemoizedSelector<object, ServiceCatalogState> = createFeatureSelector<ServiceCatalogState>(stateName);

export const getError = (state: ServiceCatalogState): any => state.error;
export const getIsLoading = (state: ServiceCatalogState): boolean => state.isLoading;
export const getSelected = (state: ServiceCatalogState): ServiceModel => state.selected;
export const getFiltered = (state: ServiceCatalogState): ServiceModel[] => state.filtered;

export const selectError: MemoizedSelector<object, any> = createSelector(selectEntityState, getError);
export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectEntityState, getIsLoading);
export const selectSelected: MemoizedSelector<object, ServiceModel> = createSelector(selectEntityState, getSelected);
export const selectFiltered: MemoizedSelector<object, ServiceModel[]> = createSelector(selectEntityState, getFiltered);

export const selectAll: (state: object) => ServiceModel[] = adapter.getSelectors(selectEntityState).selectAll;
